export { default as SerpStoreReturnSlot } from './SerpStoreReturnSlot';
